import { AuthServiceFactory } from '@asurion-core/frontend-utils/lib/AuthService';
import environment from '../environment';
import * as LogAdapter from './ErrorService/LogAdapter';

const authLogger = {
  error: (message, error) => {
    LogAdapter.logError({ customMessage: message, error });
  },
  debug: (message) => {
    LogAdapter.logMessage(message);
  },
  info: (message) => {
    LogAdapter.logMessage(message);
  },
};

const AuthService = AuthServiceFactory.create(environment.services.authServiceUrl, authLogger);

export default AuthService;
